import { Injectable } from '@angular/core';
import { ToastData, ToastOptions, ToastaService, ToastaConfig } from 'ngx-toasta';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    private static toastaService: ToastaService;

    static ToastaService() {
        if (!this.toastaService) {
            const config = new ToastaConfig();
            config.position = 'top-right';
            config.timeout = 10;
            config.theme = 'bootstrap';

            this.toastaService = new ToastaService(config);
        }
        return this.toastaService;
    }

    constructor(
        private toastaService: ToastaService,
        private toastaConfig: ToastaConfig
    ) {
        this.toastaConfig.theme = 'bootstrap';
    }

    success(message: string) {
        const toastOptions: ToastOptions = {
            title: 'Erfolg',
            msg: message,
            onAdd: (toast: ToastData) => {
                /* added */
            },
            onRemove: (toast: ToastData) => {
                /* removed */
            }
        };
        this.toastaService.success(toastOptions);
    }

    error(message: string) {
        const toastOptions: ToastOptions = {
            title: 'Fehler',
            msg: message,
            onAdd: (toast: ToastData) => {
                /* added */
            },
            onRemove: (toast: ToastData) => {
                /* removed */
            }
        };
        this.toastaService.error(toastOptions);
    }

    warning(message: string) {
        const toastOptions: ToastOptions = {
            title: 'Warnung',
            msg: message,
            onAdd: (toast: ToastData) => {
                /* added */
            },
            onRemove: (toast: ToastData) => {
                /* removed */
            }
        };
        this.toastaService.warning(toastOptions);
    }

    fatal(message: string) {
        const toastOptions: ToastOptions = {
            title: 'Fehler',
            msg: message,
            onAdd: (toast: ToastData) => {
                /* added */
            },
            onRemove: (toast: ToastData) => {
                /* removed */
            },
            timeout: 0
        };
        this.toastaService.warning(toastOptions);
    }


}
